import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {isUnitLinkedPortfolio} from 'src/app/domain/model/customer-portfolio.model';
import CustomerPortfolioApi from 'src/app/domain/service/api/customer-portfolio.api';
import {Router} from 'src/app/infrastructure/router/router';

@Injectable({
  providedIn: 'root'
})

export class SelectedPortfolioIsUnitLinkedGuard  {
  constructor(private portfolioApi: CustomerPortfolioApi, private router: Router) {
  }

  canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const selectedPortfolio = this.portfolioApi.syncSelected();

    if (!isUnitLinkedPortfolio(selectedPortfolio)) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  };
}
